import { httpClient } from 'app/api/http/http-client';
import { useMutation } from 'react-query';
import { LoginResponseType, LoginRequestType } from 'app/utils/services/types/login.type';

const authService = {
  loginWithEmail: async (data: LoginRequestType): Promise<LoginResponseType> => {
    try {
      const result = await httpClient.post<LoginResponseType>('/api-web/v1/main/authorization_b2b', data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }
    }
  },
};

export const useLoginWithEmailService = () => {
  const {
    isLoading: isLoadingLogWithEmail,
    data: dataLogWithEmail,
    mutate: loginMutation,
  } = useMutation(['loginWithEmail'], (data: LoginRequestType) => authService.loginWithEmail(data));

  return { isLoadingLogWithEmail, dataLogWithEmail, loginMutation };
};
